module.exports = __webpack_public_path__ + "img/PXL_20230523_142016663.71fc4109.jpg";